/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentAvailability } from './AppointmentAvailability';
import {
    AppointmentAvailabilityFromJSON,
    AppointmentAvailabilityFromJSONTyped,
    AppointmentAvailabilityToJSON,
    AppointmentAvailabilityToJSONTyped,
} from './AppointmentAvailability';

/**
 * 
 * @export
 * @interface UpdateAppointmentRequest
 */
export interface UpdateAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    purposeKey: string;
    /**
     * 
     * @type {AppointmentAvailability}
     * @memberof UpdateAppointmentRequest
     */
    availability: AppointmentAvailability;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAppointmentRequest
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAppointmentRequest
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    clientId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    substituteCounselorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    originTimeZoneId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    notifyBySms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    notifyByEmail?: boolean;
}



/**
 * Check if a given object implements the UpdateAppointmentRequest interface.
 */
export function instanceOfUpdateAppointmentRequest(value: object): value is UpdateAppointmentRequest {
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    return true;
}

export function UpdateAppointmentRequestFromJSON(json: any): UpdateAppointmentRequest {
    return UpdateAppointmentRequestFromJSONTyped(json, false);
}

export function UpdateAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purposeKey': json['purposeKey'],
        'availability': AppointmentAvailabilityFromJSON(json['availability']),
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'isAllDay': json['isAllDay'] == null ? undefined : json['isAllDay'],
        'location': json['location'] == null ? undefined : json['location'],
        'details': json['details'] == null ? undefined : json['details'],
        'substituteCounselorId': json['substituteCounselorId'] == null ? undefined : json['substituteCounselorId'],
        'originTimeZoneId': json['originTimeZoneId'] == null ? undefined : json['originTimeZoneId'],
        'notifyBySms': json['notifyBySms'] == null ? undefined : json['notifyBySms'],
        'notifyByEmail': json['notifyByEmail'] == null ? undefined : json['notifyByEmail'],
    };
}

export function UpdateAppointmentRequestToJSON(json: any): UpdateAppointmentRequest {
    return UpdateAppointmentRequestToJSONTyped(json, false);
}

export function UpdateAppointmentRequestToJSONTyped(value?: UpdateAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purposeKey': value['purposeKey'],
        'availability': AppointmentAvailabilityToJSON(value['availability']),
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'clientId': value['clientId'],
        'isAllDay': value['isAllDay'],
        'location': value['location'],
        'details': value['details'],
        'substituteCounselorId': value['substituteCounselorId'],
        'originTimeZoneId': value['originTimeZoneId'],
        'notifyBySms': value['notifyBySms'],
        'notifyByEmail': value['notifyByEmail'],
    };
}

